/**
 * Module dependencies.
 */

import { notification } from 'antd';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Button } from '../button/button';
import { MdContentCopy } from 'react-icons/md';

/**
 * `Props` type.
 */

type Props = {
  children: string;
  truncate?: boolean;
};

/**
 * `HoverLabel` styled component.
 */

const HoverLabel = styled.div`
  position: absolute;
  background-color: white;
  padding: 6px 32px 6px 0;
  font-size: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  gap: 16px;
  display: none;
  align-items: center;
`;

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  font-size: 10px;

  &:hover ${HoverLabel} {
    display: flex;
  }
`;

/**
 * Export `IdCopy` component.
 */

export function IdCopy({ children, truncate = true }: Props): JSX.Element {
  const [api, contextHolder] = notification.useNotification();

  const handleClick = useCallback(
    async (event: any) => {
      try {
        event.stopPropagation();

        await navigator.clipboard.writeText(children);

        api.success({
          key: `success-${new Date().getTime()}`,
          message: 'ID copiado com sucesso'
        });
      } catch (err) {
        console.error('Falha ao copiar: ', err);
      }
    },
    [api, children]
  );

  return (
    <>
      {contextHolder}

      <Wrapper onClick={handleClick}>
        {truncate ? children?.substring(0, 8) : children}

        <HoverLabel>
          <Button onClick={handleClick} size={'small'} type={'text'}>
            <MdContentCopy />
          </Button>

          {children}
        </HoverLabel>
      </Wrapper>
    </>
  );
}
